import { createAsyncThunk } from "@reduxjs/toolkit";
import userApi from "../../utils/api/userApi";

export const fetchCustomerListByEmail = createAsyncThunk(
  "customerList/fetchByEmail",
  async (emailId, { rejectWithValue }) => {
    try {
      return await userApi.getCustomerListByEmail(emailId);
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: error.message });
    }
  }
);
